import { CollectionView } from '@glu/core';

export default CollectionView.extend({
  className: 'filter-row',

  itemViewOptions() {
    return {
      masterCollection: this.masterCollection,
      columns: this.columns,
      filters: this.filters
    };
  },

  initialize() {
    this.columns = this.options.columns;
    this.filters = this.options.filters;
    this.masterCollection = this.options.masterCollection;
  }
});
